export const UPDATE_INSTALLER = {
  START: 'UPDATE_INSTALLER_START',
  SUCCESS: 'UPDATE_INSTALLER_SUCCESS',
  ERROR: 'UPDATE_INSTALLER_ERROR',
};

export const FETCH_INSTALLER_INFO = {
  START: 'FETCH_INSTALLER_INFO_START',
  SUCCESS: 'FETCH_INSTALLER_INFO_SUCCESS',
  ERROR: 'FETCH_INSTALLER_INFO_ERROR',
};

export const FETCH_AVAILABLE_MS = {
  START: 'FETCH_AVAILABLE_MS_START',
  SUCCESS: 'FETCH_AVAILABLE_MS_SUCCESS',
  ERROR: 'FETCH_AVAILABLE_MS_ERROR',
};

export const FETCH_MS_VERSIONS = {
  START: 'FETCH_MS_VERSIONS_START',
  SUCCESS: 'FETCH_MS_VERSIONS_SUCCESS',
  ERROR: 'FETCH_MS_VERSIONS_ERROR',
};

export const INSTALLER_REMOVE_MS = {
  START: 'INSTALLER_REMOVE_MS_START',
  SUCCESS: 'INSTALLER_REMOVE_MS_SUCCESS',
  ERROR: 'INSTALLER_REMOVE_MS_ERROR',
};

export const INSTALLER_UPDATE_MS_VERSION = {
  START: 'INSTALLER_UPDATE_MS_VERSION_START',
  SUCCESS: 'INSTALLER_UPDATE_MS_VERSION_SUCCESS',
  ERROR: 'INSTALLER_UPDATE_MS_VERSION_ERROR',
};

export const INSTALLER_INSTALL_MS = {
  START: 'INSTALLER_INSTALL_MS_START',
  SUCCESS: 'INSTALLER_INSTALL_MS_SUCCESS',
  ERROR: 'INSTALLER_INSTALL_MS_ERROR',
};

export const INSTALLER_START_MS = {
  START: 'INSTALLER_START_MS_START',
  SUCCESS: 'INSTALLER_START_MS_SUCCESS',
  ERROR: 'INSTALLER_START_MS_ERROR',
};

export const INSTALLER_STOP_MS = {
  START: 'INSTALLER_STOP_MS_START',
  SUCCESS: 'INSTALLER_STOP_MS_SUCCESS',
  ERROR: 'INSTALLER_STOP_MS_ERROR',
};

export const INSTALLER_FETCH_MS_CONFIG = {
  START: 'INSTALLER_FETCH_MS_CONFIG_START',
  SUCCESS: 'INSTALLER_FETCH_MS_CONFIG_SUCCESS',
  ERROR: 'INSTALLER_FETCH_MS_CONFIG_ERROR',
};

export const INSTALLER_SET_MS_CONFIG = {
  START: 'INSTALLER_SET_MS_CONFIG_START',
  SUCCESS: 'INSTALLER_SET_MS_CONFIG_SUCCESS',
  ERROR: 'INSTALLER_SET_MS_CONFIG_ERROR',
};

export const SET_MS_LOCAL_ENDPOINT = {
  START: 'SET_MS_LOCAL_ENDPOINT_START',
  SUCCESS: 'SET_MS_LOCAL_ENDPOINT_SUCCESS',
  ERROR: 'SET_MS_LOCAL_ENDPOINT_ERROR',
};
export const INSTALLER_LOADER = {
  START: 'INSTALLER_LOADER_START',
  STOP: 'INSTALLER_LOADER_STOP',
};

export const SET_IS_PRODUCTION = 'SET_IS_PRODUCTION';

export const integrationMapper = {
  chase: {
    id: 'chase',
    name: 'Chase',
    type: 'payment',
    entity: '',
  },
  wrapper: {
    id: 'wrapper',
    name: 'Wrapper',
    type: 'payment',
    entity: '',
  },
  netsCloud: {
    id: 'netsCloud',
    name: 'Nets Finland',
    type: 'payment',
    entity: '',
  },
  adyen: {
    id: 'adyen',
    name: 'Adyen',
    type: 'payment',
    entity: 'adyen-integration',
  },
  verifone: {
    id: 'verifone',
    name: 'Verifone',
    type: 'payment',
    entity: 'verifone-fin',
  },
  triPOS: {
    id: 'triPOS',
    name: 'TriPOS',
    type: 'payment',
    entity: 'vantiv-tripos-golang-microservice',
  },
  junction: {
    id: 'junction',
    name: 'Junction',
    type: 'payment',
    entity: 'pos-junction-integration',
  },
  moneris: {
    id: 'moneris',
    name: 'Moneris',
    type: 'payment',
    entity: 'moneris-integration',
  },
  linkpos: {
    id: 'linkpos',
    name: 'Linkpos',
    type: 'payment',
    entity: 'linkpos-integration',
  },
  pax: {
    id: 'pax',
    name: 'PAX Heartland',
    type: 'payment',
    entity: 'pax-poslink-integration',
  },
  fiscalRegister: {
    id: 'fiscalRegister',
    name: 'Fiscal Register France',
    type: 'fiscalRegister',
    entity: 'transaction-chain',
  },
  miniScale: {
    id: 'miniScale',
    name: 'Mini Scale',
    type: 'scale',
    entity: 'sweda34f-scale',
  },
  pcEftpos: {
    id: 'pcEftpos',
    name: 'PC-Eftpos',
    type: 'payment',
    entity: 'pc-eftpos-integration',
  },
  cayan: {
    id: 'cayan',
    name: 'Cayan',
    type: 'payment',
    entity: 'cayan-integration',
  },
  swedbank: {
    id: 'swedbank',
    name: 'Swedbank Ingenico',
    type: 'payment',
    entity: 'swedbank-ingenico',
  },
  givexDirectDriver: {
    id: 'givexDirectDriver',
    name: 'Givex Direct driver',
    type: '',
    entity: 'givex-direct-driver',
  },
  extdevCustomerDisplay: {
    id: 'extdevCustomerDisplay',
    name: 'Microservice of external devices',
    type: 'customerDisplay',
    entity: 'extdev-microservice',
  },
  extdevScale: {
    id: 'extdevScale',
    name: 'Microservice of external devices',
    type: 'scale',
    entity: 'extdev-microservice',
  },
  extdevIdCard: {
    id: 'extdevIdCard',
    name: 'Microservice of external devices',
    type: 'idCard',
    entity: 'extdev-microservice',
  },
  fairbanksScale: {
    id: 'fairbanksScale',
    name: 'Fairbanks scale',
    type: 'scale',
    entity: 'scale-fairbanks',
  },
  tsysCanada: {
    id: 'tsysCanada',
    name: 'TSYS Canada',
    type: 'payment',
    entity: '',
  },
};
export const integrationsByType = (type) =>
  Object.values(integrationMapper).filter(
    (integration) => integration?.type === type,
  );

export const entityMapper = Object.fromEntries(
  Object.entries(integrationMapper)
    .filter(([, v]) => v.entity)
    .map(([key, value]) => [value.entity, { ...value, integration: key }]),
);
